import React from 'react';
import Layout from 'gatsby-theme-core/src/layout/layout';
import Sections from 'gatsby-theme-pagebuilder/src/components/sections';

const Homepage = ({ data }) => {
  const {
    contentSections = [],
    pagebuilderSectionsComponents = [],
  } = data.homepage;

  if ((contentSections || []).length > 0) {
    return (
      <Sections sections={contentSections} />
    );
  }

  return (
    <Sections sections={(pagebuilderSectionsComponents || []).map(({ section }) => section)} />
  );
};

const HomepageLayout = (props) => (
  <Layout
    {...props.data.homepage}
    slug="/"
  >
    <Homepage {...props} />
  </Layout>
);

export default HomepageLayout;
